export default () => {
    return <i className="fa fa-circle-o-notch fa-spin"/>;
}
